
const digest = '43bcc0ac06cba68ee8115d0ddf6248413ff9cdb8a3d9cd0000ac9ed61d8ef63d';
const classes = {"wrapper":"_wrapper_gnr41_1","wrapperInline":"_wrapperInline_gnr41_5","inlineInputWrapper":"_inlineInputWrapper_gnr41_12","optional":"_optional_gnr41_19"};
const css = `._wrapper_gnr41_1 {
  margin-bottom: 10px;
}

._wrapperInline_gnr41_5 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-bottom: 10px;
}

._inlineInputWrapper_gnr41_12 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

._optional_gnr41_19 {
  display: inline-block;
  font-size: 10px;
  font-weight: 500;
  color: #909090;
  text-align: right;
  padding-bottom: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  